module.exports = __webpack_public_path__ + "static/media/suvDark.8cbef8ce.svg";